export const parseGradient = (gradient) => {
  const regex = /rgba\((\d+), (\d+), (\d+), ([\d.]+)\)/g;
  const matches = [...gradient.matchAll(regex)];

  if (matches.length === 2) {
    return {
      start: {
        color: `#${parseInt(matches[0][1])
          .toString(16)
          .padStart(2, "0")}${parseInt(matches[0][2])
          .toString(16)
          .padStart(2, "0")}${parseInt(matches[0][3])
          .toString(16)
          .padStart(2, "0")}`,
        opacity: parseFloat(matches[0][4]),
      },
      end: {
        color: `#${parseInt(matches[1][1])
          .toString(16)
          .padStart(2, "0")}${parseInt(matches[1][2])
          .toString(16)
          .padStart(2, "0")}${parseInt(matches[1][3])
          .toString(16)
          .padStart(2, "0")}`,
        opacity: parseFloat(matches[1][4]),
      },
    };
  }

  // Default colors if parsing fails
  return {
    start: { color: "#965fbe", opacity: 0.645 },
    end: { color: "#4e2b57", opacity: 0.175 },
  };
};
